@import "src/helpers/ScreenSizes.scss";

.cardListRadioButton {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-user-select: none;
  appearance: none;
  user-select: none;
  margin: 15px 24px 15px 15px;
  width: 24px;
  height: 24px;
  display: flex;
  box-sizing: border-box;
  border-radius: 5000px;
  border: 2px solid #16182b;
  pointer-events: none;
  @include small() {
    margin: 15px 15px;
  }
}

.cardListRadioButton:checked {
  border: 2px solid #4d5ef2;
}

.radioSpan {
  margin: 21px 0px 21px 21px;
  width: 12px;
  height: 12px;
  position: absolute;
  display: flex;
  border-radius: 5000px;
  background-color: #16182b;
  visibility: hidden;
}

.parent {
  cursor: pointer;
  border: none;
  width: 100%;
  max-width: 565px;
  height: 54px;
  margin: auto;
  margin-bottom: 16px;
  margin-top: 2px;
  display: flex;
  position: relative;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  @include small() {
    height: 58px;
  }
}

.parent:disabled {
  cursor: auto;
}

.parent input[type="radio"]:checked ~ .radioSpan {
  background-color: #4d5ef2;
  visibility: visible;
}

.cardTextDiv {
  flex-direction: column;
  margin-left: 0px;
}

@mixin cardText() {
  font-family: "Inter";
  font-style: normal;
  color: #16182b;
  text-align: start;
}

.cardName {
  @include cardText();
  margin-top: 10px;

  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  opacity: 0.5;
}

.loadingSpinner {
  margin: 21px 0 21px 0;
}

.cardPan {
  @include cardText();
  margin-top: 4px;

  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
}

.selectedBorder {
  outline: 2px solid #4d5ef2;
  outline-offset: -2px;
}

.cardImage {
  height: 32px;
  margin: 11px 16px 11px 0px;
  @include small() {
    width: 51px;
  }
}

.greyScale {
  filter: grayscale(1);
}

.expiredText {
  @include cardText();
  margin-left: auto;
  margin-right: 15px;
  display: flex;
  align-self: center;

  color: #4a4848;
  opacity: 0.5;

  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
}
